import { Box } from '@factorialco/deprecated-design-system'

import SingleChoice from 'modules/core/components/Filter/filters/SingleChoice'
import i18n from 'modules/core/lib/i18n'

type directionType = 'asc' | 'desc'

interface SoftwareListFiltersProps {
  direction: directionType | undefined
  setDirection: (direction: directionType | undefined) => void
  attribute: string
  setAttribute: (attribute: string) => void
}

const DIRECTION_TYPE: { asc: directionType; desc: directionType } = {
  asc: 'asc',
  desc: 'desc',
}

const SoftwareListFilters = ({
  direction,
  setDirection,
  attribute,
  setAttribute,
}: SoftwareListFiltersProps) => {
  const handleChange = (value: string | undefined, attribute: string) => {
    setAttribute(attribute)
    setDirection(value as directionType | undefined)
  }

  const DATE_OPTIONS = [
    {
      value: DIRECTION_TYPE.desc,
      label: i18n.t('it_management.software_setups.list.filter.options.creation_date_desc'),
    },
    {
      value: DIRECTION_TYPE.asc,
      label: i18n.t('it_management.software_setups.list.filter.options.creation_date_asc'),
    },
  ]

  const NAME_OPTIONS = [
    {
      value: DIRECTION_TYPE.desc,
      label: i18n.t('it_management.software_setups.list.filter.options.name_desc'),
    },
    {
      value: DIRECTION_TYPE.asc,
      label: i18n.t('it_management.software_setups.list.filter.options.name_asc'),
    },
  ]

  const EMPLOYEES_OPTIONS = [
    {
      value: DIRECTION_TYPE.desc,
      label: i18n.t('it_management.software_setups.list.filter.options.number_of_employees_desc'),
    },
    {
      value: DIRECTION_TYPE.asc,
      label: i18n.t('it_management.software_setups.list.filter.options.number_of_employees_asc'),
    },
  ]

  return (
    <Box width="full" flexDirection="row" gap="s8">
      <SingleChoice
        label={i18n.t('it_management.software_setups.list.filter.fields.creation_date')}
        value={attribute == 'date' ? direction : undefined}
        onValueChange={(value) => {
          handleChange(value, 'date')
        }}
        options={DATE_OPTIONS}
      />
      <SingleChoice
        label={i18n.t('it_management.software_setups.list.filter.fields.name')}
        value={attribute == 'name' ? direction : undefined}
        onValueChange={(value) => {
          handleChange(value, 'name')
        }}
        options={NAME_OPTIONS}
      />
      <SingleChoice
        label={i18n.t('it_management.software_setups.list.filter.fields.number_of_employees')}
        value={attribute == 'employees' ? direction : undefined}
        onValueChange={(value) => {
          handleChange(value, 'employees')
        }}
        options={EMPLOYEES_OPTIONS}
      />
    </Box>
  )
}

export default SoftwareListFilters
